module.exports = __webpack_public_path__ + "img/send.52a20742.svg";